import React from "react";
import { Container } from "@/components/common";
import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";

export function Consultation() {
  return (
    <div data-testid="consultation-page">
      <PageHero label="Patients & Caregivers" title="Request a Consultation"
        intro="Complete the form below to request a consultation with Dr. Sirohi's team. We will respond as soon as possible."
        image="https://images.unsplash.com/photo-1496865534669-25ec2a3a0fd3?crop=entropy&cs=srgb&fm=jpg" />
      <section className="bg-white py-16">
        <Container className="max-w-4xl">
          <EnquiryForm type="consultation" allowUpload submitLabel="Request Consultation" fields={[
            { name: "name", label: "Full Name", required: true },
            { name: "email", label: "Email", type: "email", required: true },
            { name: "phone", label: "Phone" },
            { name: "country", label: "Country" },
            { name: "city", label: "City" },
            { name: "concern", label: "Area of Medical Concern" },
            { name: "consultation_format", label: "Preferred Consultation Format", options: ["In-person", "Video call", "Telephone"] },
            { name: "preferred_datetime", label: "Preferred Date/Time" },
            { name: "message", label: "Message", area: true },
          ]} />
          <p className="mt-6 text-xs text-softgrey-400">For medical emergencies, contact your local healthcare provider or emergency services immediately. This form does not provide urgent medical care.</p>
        </Container>
      </section>
    </div>
  );
}

export function SecondOpinion() {
  return (
    <div data-testid="second-opinion-page">
      <PageHero label="Patients & Caregivers" title="Request a Second Opinion"
        intro="Share your diagnosis and relevant information to request a second opinion. Uploaded documents are stored securely and confidentially."
        image="https://images.unsplash.com/photo-1773984203620-e73698b3fbe5?crop=entropy&cs=srgb&fm=jpg" />
      <section className="bg-white py-16">
        <Container className="max-w-4xl">
          <EnquiryForm type="second_opinion" allowUpload submitLabel="Request Second Opinion" fields={[
            { name: "name", label: "Full Name", required: true },
            { name: "email", label: "Email", type: "email", required: true },
            { name: "phone", label: "Contact Number" },
            { name: "country", label: "Country" },
            { name: "diagnosis", label: "Diagnosis", area: true },
            { name: "previous_treatment", label: "Previous Treatment", area: true },
            { name: "main_question", label: "Main Question", area: true },
            { name: "medical_info", label: "Relevant Medical Information", area: true },
          ]} />
        </Container>
      </section>
    </div>
  );
}
